/* eslint-disable no-unused-expressions */
import _reducer from 'lodash/reduce';

// eslint-disable-next-line max-len
export const widthCalculator = (compatibilitySegments, getSkuProductDimensions) => (fullProductGroupNames, halfProductGroupNames, baseProductGroupsNames) => {
  let maxFullGroupWidth = 0;
  let leftWidth = 0;
  let rightWidth = 0;

  if (baseProductGroupsNames.length === 1) {
    const baseSKu = compatibilitySegments[baseProductGroupsNames[0]][0].Sku;
    const baseSKuDims = getSkuProductDimensions(baseSKu);
    maxFullGroupWidth = baseSKuDims?.width;
  }

  if (fullProductGroupNames) {
    fullProductGroupNames.forEach((fullProductGroupName) => {
      const currentMaxFullGroupWidth = _reducer(compatibilitySegments[fullProductGroupName],
        (max, compatibilitySegment) => {
          const currentWidthDims = getSkuProductDimensions(compatibilitySegment.Sku);
          return (currentWidthDims?.width > max) ? currentWidthDims?.width : max;
        }, 0);
      maxFullGroupWidth = (currentMaxFullGroupWidth > maxFullGroupWidth)
        ? currentMaxFullGroupWidth : maxFullGroupWidth;
    });
  }

  if (halfProductGroupNames) {
    halfProductGroupNames.forEach((halfProductGroupName) => {
        compatibilitySegments[halfProductGroupName]?.forEach((compatibilitySegment) => {
          const currentWidthDims = getSkuProductDimensions(compatibilitySegment.Sku);
          if (halfProductGroupName.endsWith('1')) {
            leftWidth = currentWidthDims?.width > leftWidth ? currentWidthDims?.width : leftWidth;
          } else {
            rightWidth = currentWidthDims?.width > rightWidth ? currentWidthDims?.width : rightWidth;
          }
        });
    });
  }

  if ((leftWidth + rightWidth) > maxFullGroupWidth) {
    return (leftWidth + rightWidth);
  }

  if (leftWidth > 0 && rightWidth > 0) {
    if ((leftWidth + rightWidth) > maxFullGroupWidth) {
      return (leftWidth + rightWidth);
    }
  }

  if (leftWidth > 0) {
    if ((leftWidth + maxFullGroupWidth / 2) > maxFullGroupWidth) {
      return leftWidth + maxFullGroupWidth / 2;
    }
  }

  if (rightWidth > 0) {
    if ((rightWidth + maxFullGroupWidth / 2) > maxFullGroupWidth) {
      return rightWidth + maxFullGroupWidth / 2;
    }
  }

  return maxFullGroupWidth;
};
